<form
  name="step.form"
  #currentForm="ngForm"
  *ngIf="step && !isLoading()"
  class="user-password"
  novalidate
>
  <div class="group" *ngIf="!canManageUsers">
    <p>Current password *</p>
    <input
      type="password"
      name="oldPassword"
      #oldPwdInput="ngModel"
      [(ngModel)]="currentPassword"
      (ngModelChange)="currentPasswordUpdated()"
      required
    />
    <div class="error" *ngIf="oldPwdInput.invalid && (oldPwdInput.dirty || oldPwdInput.touched)">
      <mat-error *ngIf="oldPwdInput.errors.required">Your current password is required</mat-error>
    </div>
  </div>

  <div class="group">
    <p>New password *</p>
    <input
      type="password"
      name="newPassword"
      [(ngModel)]="newPassword"
      [fieldMatch]="newPwdRepeatInput.control"
      [reverse]="true"
      required
      #newPwdInput="ngModel"
      passwordStrength
      [passwordValidationOptions]="passwordValidationOptions"
      (passwordScore)="step.passwordStrength = $event"
      (passwordSuggestions)="step.passwordSuggestions = $event"
      (ngModelChange)="newPasswordUpdated()"
      minlength="5"
      maxlength="30"
    />

    <div
      class="label password-count"
      [ngClass]="step.output.newPassword.length >= 5 ? 'label-success' : 'label-danger'"
    >
      {{ step.output.newPassword | passwordCount:5 }}
    </div>
    <strength-meter [passwordScore]="step.passwordStrength"></strength-meter>

    <div class="error" *ngIf="newPwdInput.invalid && (newPwdInput.dirty || newPwdInput.touched)">
      <mat-error *ngIf="newPwdInput.errors.required">Password is required<br /></mat-error>
    </div>
    <div class="error" *ngIf="newPwdInput.invalid && newPwdInput.dirty">
      <mat-error *ngIf="newPwdInput.errors.minlength"
        >Password must have at least 5 characters<br
      /></mat-error>
      <mat-error
        *ngIf="!newPwdInput.errors.minlength && newPwdInput.errors.pattern === 'bad' && userService.isActiveTestProject()"
        >The password does not meet the minimum complexity requirements: upper and lower case, at
        least one number, and one non-alphanumeric symbol.</mat-error
      >
    </div>
  </div>

  <div class="group">
    <p>Confirm new password *</p>
    <input
      type="password"
      name="newPasswordRepeat"
      [(ngModel)]="newPasswordRepeat"
      [fieldMatch]="newPwdInput.control"
      #newPwdRepeatInput="ngModel"
      (ngModelChange)="confirmPasswordUpdated()"
      required
    />
    <div
      class="error"
      *ngIf="newPwdRepeatInput.invalid && (newPwdRepeatInput.dirty || newPwdRepeatInput.touched)"
    >
      <mat-error *ngIf="newPwdRepeatInput.errors.required">Password is required<br /></mat-error>
    </div>
    <div class="error" *ngIf="newPwdRepeatInput.invalid && newPwdRepeatInput.dirty">
      <div *ngIf="!newPwdRepeatInput.errors.required">
        <mat-error *ngIf="newPwdRepeatInput.errors.fieldMatch"
          >Passwords do not match<br
        /></mat-error>
      </div>
    </div>
  </div>
</form>
<div *ngIf="isLoading()" class="loader">
  <div class="loader-msg-header">
    <p>Updating password</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
